export default __webpack_public_path__ + "static/media/seed.747cb9f3.svg";